export const demo05 = {
    "appBar": {
        "backgroundColor": "#0C0B0F",
        "mode": "dark",
        "exhibition": {
            "name": "Forrige århundrets mote",
            "description": "Bli inspirert av forrige århundrets mote!",
            "url": "https://beta.virtueltmuseum.no/museum/12/exhibition/ff335e35-98ec-4e36-9c32-79428f917b69"
        },
        "museum": {
            "name": "Museene i Akershus",
            "url": "https://beta.virtueltmuseum.no/museum/12"
        }
    },

    "sections": [
    {
        "backgroundColor": "#f28600ff",
        "backgroundImage": "019EE9DPUV8Qp",
        "containers": [
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"9hk81\",\"text\":\"Aluminium – det grønne gullet?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":30,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":30,\"style\":\"SIZE_XL7\"},{\"offset\":0,\"length\":30,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":30,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 7,
                "horizontalAlign": "center",
                "startColumn": 1
            }
        ],
        "excludeFromNav": false,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 1,
        "templateId": 1,
        "title": "Forside",
        "type": "content",
        "verticalAlign": "bottom"
    },
    {
        "backgroundColor": "#111d11ff",
        "containers": [
            {
                "backgroundColor": "#111d11ff",
                "blocks": [
                    {
                        "autoPlay": false,
                        "locked": false,
                        "showControls": true,
                        "type": "video",
                        "videoUrl": "019EE8EBk2fP8"
                    }
                ],
                "borderRadius": true,
                "endColumn": 9,
                "horizontalAlign": "center",
                "startColumn": 2
            }
        ],
        "excludeFromNav": false,
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 2,
        "templateId": 2,
        "title": "Film fra Aluminiummuseet",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundImage": [
            {
                "image": "019EE8ijLUdyJ"
            },
            {
                "image": "019EE8ijLUe3Z"
            },
            {
                "image": "019EE8ijLTxnA"
            },
            {
                "image": "019EE8ijLTxrV"
            },
            {
                "image": "019EE8ijLTy5o"
            }
        ],
        "containers": [
            {
                "backgroundColor": "#c3c5d4db",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"5tpf\",\"text\":\"Nå skal vi få møte Kim, som bor i en industribygd i Vestland fylke. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":68,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":68,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d4",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"5tpf\",\"text\":\"Her jobber mange på A/S Metallverket, som lager aluminium.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":58,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":58,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":58,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d6",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"flvge\",\"text\":\"Kim har nettopp tatt lappen og drømmer om å kjøpe bil.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":54,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":54,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"e95j4\",\"text\":\"Men han er også opptatt av klima og miljø.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":42,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":42,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d4",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"ef553\",\"text\":\"I bygda til Kim sier de at aluminium gjør biler mer miljøvennlige og verden grønnere.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":85,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":85,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"dn8b6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7bvid\",\"text\":\"Stemmer det? Det vil Kim undersøke.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":35,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":35,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d4",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"ef553\",\"text\":\"Sammen med Kim skal vi legge ut på en reise for å finne ut hvordan aluminium lages og hvor miljøvennlig det egentlig er. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":121,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"52oou\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            }
        ],
        "excludeFromNav": false,
        "gridSize": "nineColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "order": 3,
        "templateId": 6,
        "title": "Møt Kim",
        "type": "sticky"
    },
    {
        "backgroundColor": "#ffffffff",
        "containers": [
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"1jja9\",\"text\":\"Kim lurer på hvor aluminium kommer fra. Han finner ut at aluminium har noe med regnskogen å gjøre. Hvordan kan det henge sammen?  \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":130,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":130,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"6nbet\",\"text\":\"Kim reiser til delstaten Pará i Brasil for å finne ut mer. Her holder blant annet selskapet Norsk Hydro til, som er en av verdens største produsenter av aluminium. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":164,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":164,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "removable": true,
                "startColumn": 2
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "mapCoords": {
            "from": [
                6.075379121084884,
                61.219600531900426
            ],
            "to": [
                -47.64190500551681,
                -3.3387484768381483
            ]
        },
        "minHeight": "500dvh",
        "order": 4,
        "templateId": 7,
        "title": "Bauksittutvinning",
        "type": "stickyMap",
        "verticalAlign": "center",
        "zoom": 6
    },
    {
        "backgroundColor": "#c3c5d4ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"8jtph\",\"text\":\"Aluminium er et grunnstoff, men i motsetning til gull finnes ikke aluminium i ren form i naturen – det må lages.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":112,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":112,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"89gid\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"e5sti\",\"text\":\"Det hele starter med noe som heter bauksitt. Det er et stoff som kan minne om leire og som består av mange mineraler. Det finnes mest bauksitt i tropiske strøk, i Sør-Amerika, Afrika og Australia. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":197,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":197,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"dneer\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2nteg\",\"text\":\"Bauksitten ligger 10–15 meter ned i bakken, og må graves ut. I regnskogen i Pará opplever Kim at enorme skogarealer hogges for å hente ut bauksitt.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":147,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":147,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"6meb1\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"f8tde\",\"text\":\"Hogsten er en stor miljøutfordring. Regnskogen beskytter oss mot klimaendringer, den har et rikt dyre- og planteliv, og det bor millioner av mennesker her. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":156,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":156,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"fruaq\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2690c\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fhijq\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "excludeFromNav": true,
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 5,
        "templateId": 2,
        "title": "Bauksitt og regnskogen",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#111d11ff",
        "containers": [
            {
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE8ijLUJG7",
                        "showCaptionIcon": false,
                        "type": "image"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"6ab1b\",\"text\":\"Bauksittgruve i regnskogen i Brasil. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":37,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":37,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":37,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"32dh4\",\"text\":\"Foto: Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":12,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":12,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":12,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 7,
                "horizontalAlign": "center",
                "startColumn": 4
            }
        ],
        "excludeFromNav": true,
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 6,
        "templateId": 2,
        "title": "Bauksitt og regnskogen",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#111d11ff",
        "containers": [
            {
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE8ijLUe3a",
                        "showCaptionIcon": false,
                        "type": "image"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"6ab1b\",\"text\":\"Avskoging i regnskogen i Brasil. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":33,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":33,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":33,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"fft29\",\"text\":\"Foto: Luoman, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":21,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":21,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":21,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 7,
                "horizontalAlign": "center",
                "startColumn": 4
            }
        ],
        "excludeFromNav": true,
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 7,
        "templateId": 2,
        "title": "Bauksitt og regnskogen",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#1e4f32ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"8jtph\",\"text\":\"Norsk aluminiumindustri forsøker å redusere skadene som utvinning av bauksitt skaper. De prøver å plante ny regnskog, og det brukes store summer på forskning. Vil de lykkes?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":173,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":173,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":173,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3qd4n\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"29gci\",\"text\":\"Ja, sier industrien, men forskerne er skeptiske. Det er mange spørsmål og få svar, sier de. Kim blir usikker på hva som er rett, og vil undersøke de ulike meningene nærmere.  \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":175,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":175,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":175,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"fhijq\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 7,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE8ijLUe3b",
                        "showCaptionIcon": false,
                        "type": "image"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fg35u\",\"text\":\"Hydro jobber med å gjenplante regnskog. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":40,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":40,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":40,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"e3lrm\",\"text\":\"Foto: Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":12,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":12,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":12,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "startColumn": 7
            }
        ],
        "excludeFromNav": true,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 8,
        "templateId": 2,
        "title": "Bauksitt og regnskogen",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#8fbad8ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"c6l6e\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"dt74l\",\"text\":\"Se gjennom de ulike kildene og finn ut mer om bauksittutvinning.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":64,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":64,\"style\":\"BOLD\"},{\"offset\":0,\"length\":64,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"1oqia\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"452tl\",\"text\":\"Hvem er avsender? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":18,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":18,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"6mdep\",\"text\":\"Hva mener de ulike personene? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":30,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":30,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"dhedb\",\"text\":\"Hvem synes dere er mest troverdige?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":35,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":35,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"6m9id\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"577i\",\"text\":\"«Et lite stykke regnskog»\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":25,\"style\":\"BOLD\"},{\"offset\":0,\"length\":25,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fgdt8\",\"text\":\"NRK Brennpunkt har laget en god dokumentar om Hydros virksomhet i Brasil. Her tar de opp konflikten mellom Hydro og urfolk som lever i området rundt aluminiumsanlegg.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":166,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "autoPlay": false,
                                "showControls": false,
                                "type": "video",
                                "videoUrl": "019EE8icttmho"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"3b481\",\"text\":\"Kilde: NRK Brennpunkt. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5c4qf\",\"text\":\"Publisert 13.12.2018. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"a8jp8\",\"text\":\"Lenke til kilde: https://tv.nrk.no/serie/brennpunkt/2018/MDDP11001118 \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Se film",
                        "contentType": "dialog",
                        "icon": "movie",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"577i\",\"text\":\"«Norges to ansikter i regnskogen» \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":34,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":34,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fgdt8\",\"text\":\"I denne artikkelen ser NRK på konsekvensene av aluminiumsproduksjonen for folk og natur i regnskogen, og hvordan Hydro forsøker å redusere disse. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":146,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"dhd8\",\"text\":\"NRK konfronterer leder for bauksitt og alumina i Hydro, John Thuestad, i dette intervjuet. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":91,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"9cfvh\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "text": "{\"blocks\":[{\"key\":\"6h4rq\",\"text\":\"MRNs gruver ligger midt i et verneområde med uberørt regnskog. Hvordan synes du det henger sammen med at man må redde regnskogen i Amazonas?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":140,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"uvn2\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6svn3\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"n4ku\",\"text\":\"– Vi forholder oss til at brasilianske myndigheter har regulert dette området til en kombinasjon av naturreservat og bauxittutvinning, svarer John Thuestad.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":156,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"696s7\",\"text\":\"– Vi gjør dette på en ansvarlig måte, sier Thuestad.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":52,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"a4rcs\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"92pru\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"596cu\",\"text\":\"Ansvarlig gruvedrift i regnskogen betyr for Norsk Hydro gjenplanting av områdene etter at bauxitten er hentet ut. Både i Paragominas og Trombetas jobbes det systematisk med dette:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":179,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bep7g\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"ct8l8\",\"text\":\"Etter at skogen kappes ned, legges matjorda til side. Så legges matjorda tilbake når bauxitten er hentet ut med maskinene. Frøene som har overlevd i matjorda, sammen med trær som plantes, skal etter planen gi regnskog tilbake i de store åpne sårene i naturen.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":259,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cv4df\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"ee2r9\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fi93f\",\"text\":\"– Vi tar da ut bauxitten på en måte som gjør at vi gjenskaper det miljøet som var der før vi tok ut bauxitten, sier Thuestad.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":125,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"pv06\",\"text\":\"– Har dere klart det?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":21,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"19ubr\",\"text\":\"– I stor grad vil jeg påstå at vi har gjort det, svarer sjefen på Hydro Alunorte.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":81,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"boe61\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"akam6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8t3bl\",\"text\":\"Kilde: NRK.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"699tc\",\"text\":\"Publisert: 06.01.2019. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"badrf\",\"text\":\"Lenke til kilde: https://www.nrk.no/dokumentar/xl/norges-to-ansikter-i-regnskogen-1.14362780\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"70hla\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les intervjuet",
                        "contentType": "dialog",
                        "icon": "newspaper",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"577i\",\"text\":\"«Hydro sier de har oversikt over artsmangfoldet i regnskogen de hogger. – Umulig, sier forsker» \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":96,\"style\":\"BOLD\"},{\"offset\":0,\"length\":96,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fgdt8\",\"text\":\"I denne artikkelen intervjuer forskningsmagasinet Apollon to forskere om det er mulig for Hydro å gjenskape regnskogen i Brasil. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":129,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"hi1v\",\"text\":\"Einar Timdal og Sonja Kistenich på Naturhistorisk museum er kritiske til dette. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":80,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"2k0p5\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "text": "{\"blocks\":[{\"key\":\"6h4rq\",\"text\":\"Hydro sier at målet er å skaffe oversikt over artsmangfoldet i regnskogen før bulldoserne kommer.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":97,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cenqr\",\"text\":\"– Det er ikke mulig. Kanskje de brasilianske samarbeidspartnerne til Hydro har oversikt over fuglene, pattedyrene og de vanligste treslagene, men mangfoldet i en tropisk regnskog er så stort at verken de eller noen andre er i nærheten av å vite hva som lever der.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":263,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7mpec\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1sa5m\",\"text\":\"– Når det gjelder lav, kan ingen si noe som helst om hva som finnes i regnskogen i Paragominas. Det har nemlig ikke vært noen andre lavforskere der enn meg og en kollega. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":171,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2af7b\",\"text\":\"– Og når ingen vet det, er det heller ikke mulig å kontrollere om, og eventuelt når, det opprinnelige mangfoldet av arter er tilbake.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":133,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"5h8ci\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6h7rk\",\"text\":\"– Noen kan sikkert finne økonomiske grunner til å bevare lav, moser og karplanter, men for meg er det først og fremst et moralsk spørsmål.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":138,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"e2ueb\",\"text\":\"– Det aller fineste vi har på jorda, er livet i all sin variasjon. Det er uendelig mange grunner til å la regnskogen stå.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":121,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8f1lv\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6rgc6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1hj9s\",\"text\":\"Kilde: Apollon. Forskningsmagasinet til Universitetet i Oslo.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"cb346\",\"text\":\"Publisert: 30.04.2019. Sist endret 27.08.2019.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"d4spn\",\"text\":\"Lenke til kilde: https://www.apollon.uio.no/artikler/2019/2_amazonas_lav_sopp.html \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":83,\"style\":\"UNDERLINE\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"a9h6k\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les intervjuet",
                        "contentType": "dialog",
                        "icon": "newspaper",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"577i\",\"text\":\"«Hydro i regnskogen: Først rasere, så rekonstruere»\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":51,\"style\":\"BOLD\"},{\"offset\":0,\"length\":51,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fgdt8\",\"text\":\"Hydro samarbeider med Universitetet i Oslo om å gjenskape regnskogen i Brasil, men lar det seg gjøre? I denne artikkelen intervjues blant annet Bernt Malme, miljøsjef i Hydro, og Fridtjof Mehlum, forsker ved Naturhistorisk museum \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":230,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "text": "{\"blocks\":[{\"key\":\"6h4rq\",\"text\":\"Er det mulig å få regnskogen tilbake med alt sitt mangfold? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":60,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"e5053\",\"text\":\"Hydro mener de ligger godt an. Selskapet har uttalt at rehabiliteringsgapet de overtok da de kjøpte gruveområdet, skal tas igjen innen 2020. Ifølge miljøsjef Bern Malme i Hydro, går alt etter planen. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":200,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"86ehu\",\"text\":\"– Veier og annen infrastruktur må vi riktignok gjenplante seinere, nyanserer han.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":81,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8cb1d\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"4rjsm\",\"text\":\"Fridtjof Mehlum er mer pessimistisk.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":36,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"dk0q4\",\"text\":\"– Å oppnå samme biomasse som før, det vil si den totale vekten av alle levende organismer, er det første vi kan håpe på. Det tar kanskje 50 år. Men da er det snakk om en annen og langt fattigere sammensetning av arter enn i regnskogen. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":236,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"amgrk\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"9rbl5\",\"text\":\"– Er Hydro vel optimistiske når det gjelder å gjenskape regnskogen? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":68,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"36pr2\",\"text\":\"– Ja, om vi hører på det selskapet uttaler til pressen. Leser vi Hydros miljømål, ser vi at de er ganske ambisiøse. Om de klarer å etterleve dem, er en annen sak. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":163,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"73omn\",\"text\":\"De sier at de vil gjenplante like mye som de ødelegger. Men vi blir litt lurt. For den skogen Hydro hogger ned, er ikke den samme som kommer opp. Det tar tid å lage regnskog.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":174,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"crk4r\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2t4nf\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8if1p\",\"text\":\"Kilde: Forskning.no. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"9bi1b\",\"text\":\"Publisert: 22.05.2019. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"60j8\",\"text\":\"Lenke til kilde: https://www.forskning.no/klima-miljogifter-miljovern/hydro-i-regnskogen-forst-rasere-sa-rekonstruere/1339193\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les intervjuet",
                        "contentType": "dialog",
                        "icon": "newspaper",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "excludeFromNav": false,
        "gridSize": "nineColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 9,
        "templateId": 2,
        "title": "Oppgave bauksittutvinning",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#ffffffff",
        "containers": [
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"c8p49\",\"text\":\"Hva skal Kim tro? Det blir ikke lettere når han følger bauksitten til et raffineri i Barcarena i Brasil. Raffinere betyr å rense et råstoff. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":141,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":141,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":141,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"ep8fi\",\"text\":\"På raffineriet begynner jobben med å gjøre om bauksitt til metallet aluminium. Hvordan skjer det? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":98,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":98,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":98,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "mapCoords": {
            "from": [
                -47.65533224010779,
                -3.213681511100674
            ],
            "to": [
                -48.73246927130359,
                -1.5385608481317945
            ]
        },
        "minHeight": "500dvh",
        "order": 10,
        "templateId": 7,
        "title": "Aluminiumoksid",
        "type": "stickyMap",
        "verticalAlign": "center",
        "zoom": 10
    },
    {
        "backgroundImage": [
            {
                "image": "019EE8ijLUe3c"
            },
            {
                "image": "019EE8ijLTyJy"
            },
            {
                "image": "019EE8ijLTxvy"
            },
            {
                "image": "019EE8EBk2evj"
            },
            {
                "image": "019EE8ijLUJG7"
            }
        ],
        "containers": [
            {
                "backgroundColor": "#c3c5d4d9",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"9bc7o\",\"text\":\"På raffineriet blir bauksitt tilsatt en varm blanding av lut og kalk. Da omdannes bauksitt til aluminiumoksid, også kalt alumina.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":129,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":129,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3g63l\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7thhd\",\"text\":\"Aluminiumoksid er et hvitt pulver som består av aluminium og oksygen, og det er…. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":82,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":82,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4db",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"150i5\",\"text\":\"helt nødvendig for å lage aluminium.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":36,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":36,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4db",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"c3se3\",\"text\":\"Omdanningen av bauksitt til aluminiumoksid etterlater mye rødslam. Det inneholder lut og tungmetaller, som er svært giftig.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":123,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":123,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4e3",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"eq6dg\",\"text\":\"Omdanningen av bauksitt til aluminiumoksid etterlater mye rødslam. Det inneholder lut og tungmetaller, som er svært giftig.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":123,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":123,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"22tr4\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"638vv\",\"text\":\"Rødslammet blir lagret i store basseng, kalt for deponier. Lekkasje fra disse vil skade miljøet.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":96,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":96,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d9",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"8ng9p\",\"text\":\"Men rødslammet kan også være en ressurs. Det inneholder mange andre metaller som kan brukes.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":92,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":92,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cgs9u\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"f2vbn\",\"text\":\"Det lages nærmere 100 millioner tonn aluminium i verden (2024). I 2050 vil behovet for aluminium være på rundt 200 millioner tonn.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":130,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":130,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            }
        ],
        "excludeFromNav": true,
        "gridSize": "nineColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "order": 11,
        "templateId": 6,
        "title": "",
        "type": "sticky"
    },
    {
        "backgroundColor": "#8fbad8ff",
        "containers": [
            {
                "backgroundColor": "#8fbad8ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"3u61h\",\"text\":\"Kim finner ut at 6 tonn bauksitt gir 2 tonn aluminiumoksid og 1 tonn aluminium.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":79,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9atsb\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5e9u0\",\"text\":\"Raffineringsprosessen vil etterlate dobbelt så mye rødslam som aluminiumoksid.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":78,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"anfqq\",\"text\":\" \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":1,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "alternatives": [
                            {
                                "alternative": "a",
                                "text": "200 millioner tonn aluminium = 1600 millioner tonn bauksitt (1,6 milliard tonn bauksitt)"
                            },
                            {
                                "alternative": "b",
                                "text": "2)\t200 millioner tonn aluminium = 1200 millioner tonn bauksitt (1,2 milliard tonn bauksitt) "
                            },
                            {
                                "alternative": "c",
                                "text": "200 millioner tonn aluminium = 800 millioner bauksitt  "
                            }
                        ],
                        "answer": "b",
                        "locked": true,
                        "question": "Hvor mange tonn bauksitt trengs for å lage 200 millioner tonn ny aluminium?",
                        "type": "quiz"
                    },
                    {
                        "alternatives": [
                            {
                                "alternative": "a",
                                "text": "200 millioner tonn aluminium = 1600 millioner tonn rødslam (1,6 milliarder tonn rødslam)"
                            },
                            {
                                "alternative": "b",
                                "text": "200 millioner tonn aluminium = 400 millioner tonn rødslam"
                            },
                            {
                                "alternative": "c",
                                "text": "200 millioner tonn aluminium = 800 millioner tonn rødslam"
                            }
                        ],
                        "answer": "a",
                        "locked": true,
                        "question": "Hvor mye rødslam vil produksjonen av 200 millioner tonn aluminium etterlate?",
                        "type": "quiz"
                    }
                ],
                "endColumn": 8,
                "horizontalAlign": "center",
                "startColumn": 3
            }
        ],
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 12,
        "templateId": 2,
        "title": "Oppgave aluminiumoksid",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#ffffffff",
        "containers": [
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"2epc5\",\"text\":\"Fra Brasil fraktes aluminiumoksid over store havstrekninger til land som lager aluminium. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":90,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":90,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":90,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"2laeo\",\"text\":\"Kim tar sjøveien tilbake til Norge.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":35,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":35,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":35,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"3k1rn\",\"text\":\"På A/S Metallverket følger han prosessen fra aluminiumoksid til aluminium på A/S. Hva skjer her? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":97,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":97,\"style\":\"color-#000000\"},{\"offset\":0,\"length\":97,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "removable": true,
                "startColumn": 2
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "mapCoords": {
            "from": [
                -48.73360642894697,
                -1.5456951554550784
            ],
            "to": [
                6.073918563859532,
                61.21729872222369
            ]
        },
        "minHeight": "500dvh",
        "order": 13,
        "templateId": 7,
        "title": "Energikilder",
        "type": "stickyMap",
        "verticalAlign": "center",
        "zoom": 8
    },
    {
        "backgroundImage": [
            {
                "image": "019EE8ijLUe3h"
            },
            {
                "image": "019EE8ijLTxw1"
            },
            {
                "image": "019EE8ijLTy1H"
            },
            {
                "image": "019EE8ijLTxvv"
            }
        ],
        "containers": [
            {
                "backgroundColor": "#c3c5d4d4",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"6ik59\",\"text\":\"På Metallverket blir aluminiumoksid til aluminium gjennom elektrolyse. Prosessen skiller oksygen fra aluminium, og krever store mengder elektrisitet.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":149,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":149,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":149,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d9",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"512p5\",\"text\":\"I Norge bruker vi vannkraft for å lage aluminium. Det daglige forbruket er like mye som det årlige forbruket til to-tre tusen husholdninger. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":141,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":141,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":141,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3jdi4\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fh58g\",\"text\":\"Kim er sjokkert over hvor mye strøm som brukes for å lage aluminium. Hvordan kan aluminium være miljøvennlig? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":110,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":110,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":110,\"style\":\"color-#000000\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d6",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"cv5c3\",\"text\":\"Når energikilden er vannkraft, er CO2-utslippet mye lavere enn utslipp fra anlegg som bruker fossile kraftkilder. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":114,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":114,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9hfmb\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5n4e6\",\"text\":\"Tenk hvor forurensende aluminiumsproduksjon er om man bruker kull som kraftkilde.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":81,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":81,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#c3c5d4d9",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"4v8hu\",\"text\":\"Industrien har som mål å redusere energibruken og bruke mer fornybar energi. Men fremdeles brukes fossile kraftkilder som kull, for å lage aluminium. Kim vil vite mer om ulike energikilder.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":189,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":189,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5,
                "stepPosition": "bottom"
            }
        ],
        "excludeFromNav": true,
        "gridSize": "nineColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "order": 14,
        "templateId": 6,
        "type": "sticky"
    },
    {
        "backgroundColor": "#8fbad8ff",
        "containers": [
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"8knh6\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6mjnp\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"9pgdk\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"9sfdc\",\"text\":\"Undersøk de ulike metodene for å lage strøm.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":44,\"style\":\"BOLD\"},{\"offset\":0,\"length\":44,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"1o6d8\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"5hu75\",\"text\":\"Hvilke metoder tror dere aluminiumindustrien globalt bruker i dag for elektrolyse? Velg ut tre.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":95,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"7lj7q\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"bsq09\",\"text\":\"Hvilke metoder ville dere brukt? Velg ut tre.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":45,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}},{\"key\":\"7o48a\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5gp6a\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"tsek\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"c30r8\",\"text\":\"Vannkraft \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":10,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":10,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"39ehv\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"62ik4\",\"text\":\"Utslippsfri\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":11,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"6h1vm\",\"text\":\"Fornybar \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"e4ett\",\"text\":\"Lar seg lagre\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":13,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"5n1ln\",\"text\":\" \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":1,\"style\":\"BOLD\"},{\"offset\":0,\"length\":1,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"63ksv\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"6f87h\",\"text\":\"Krever arealer som medfører store naturinngrep \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":47,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"c6frv\",\"text\":\"Gir tørre elver og dårlig miljø for fiskebestanden\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":50,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"au39s\",\"text\":\"Væravhengig - magasinene kan gå tomme i tørkeperioder \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":54,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"dqbqb\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"cvhb8\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"c12pr\",\"text\":\"Atomkraft\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"ev1gt\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":9,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"6r18\",\"text\":\"Krever minst areal \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":19,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cpacd\",\"text\":\"Gir minst utslipp\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":17,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"fkscg\",\"text\":\"Stabil og uavhengig av værforhold\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":33,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"768qq\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"dgjmn\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"},{\"offset\":0,\"length\":9,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"6c358\",\"text\":\"Enorme konsekvenser dersom det skjer en feil eller naturkatastrofe \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":67,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7b961\",\"text\":\"Skaper farlig avfall som må isoleres fra naturen i 100 000 år\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":61,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"4i1mi\",\"text\":\"Ingen rask løsning for å få ned utslippene\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":42,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"52d8s\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"1fms3\",\"text\":\"Vindkraft\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "text": "{\"blocks\":[{\"key\":\"e590s\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cqlsm\",\"text\":\"Fornybar \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"el942\",\"text\":\"Lavt CO2-utslipp\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":16,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"sc12\",\"text\":\"Kan konkurrere på pris med fossile energikilder\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":47,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"dnm3o\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8a198\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8njv\",\"text\":\"Legger beslag på store naturområder til land og til vanns \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":58,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"diice\",\"text\":\"Ødeleggende for dyreliv \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":24,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2g6a3\",\"text\":\"Væravhengig og produserer kraft bare ca. 35% av tida\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":52,\"style\":\"SIZE_XL\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"a6m36\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"4jk1v\",\"text\":\"Hydrogen\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":8,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":8,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"5lgcr\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8bh5g\",\"text\":\"Utslippsfritt \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":14,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"earjg\",\"text\":\"Gir mer energi enn fossile energikilder\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":39,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"b2n9r\",\"text\":\"Kan lagres\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":10,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ag6qt\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"61ekm\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"22bf3\",\"text\":\"Kan ikke brukes direkte, men må lages ved hjelp av en energikilde \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":66,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1ke3a\",\"text\":\"Produksjon krever enorme mengder med energi. Brukes fossilt brensel, vil det føre til utslipp av klimagasser\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":108,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"358fm\",\"text\":\"Transport til der den skal brukes fører til utslipp\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":51,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2kesi\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 7,
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"btb1u\",\"text\":\"Gass\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":4,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":4,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"18b1i\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"98nt\",\"text\":\"Slipper ut mindre CO2 enn kull\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":30,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"27v46\",\"text\":\"Sikker og pålitelig \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":20,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cguml\",\"text\":\"Lett tilgjengelig\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":17,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8vj5j\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"4mcbr\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d14ba\",\"text\":\"Ikke- fornybar\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":14,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2ap39\",\"text\":\"Utslipp av metan som forsterker global oppvarming\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":49,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bb90e\",\"text\":\"Leveransene kan bli påvirket av f.eks. krig\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":43,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"c2ug0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"157rj\",\"text\":\"Kull\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":4,\"style\":\"BOLD\"},{\"offset\":0,\"length\":4,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"41fie\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7oodu\",\"text\":\"Lett og rimelig å utvinne\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":25,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ad1i6\",\"text\":\"Bidrar til økonomisk vekst i utviklingsland\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":43,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8krr6\",\"text\":\"Sikker og pålitelig\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":19,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"77ih7\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"66krq\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9e8um\",\"text\":\"Ikke-fornybar\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":13,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"31bg1\",\"text\":\"Slipper ut mest CO2 av alle energikilder\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":40,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d8de2\",\"text\":\"Medfører store naturinngrep\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":27,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"4brug\",\"text\":\"Solkraft\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":8,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":8,\"style\":\"BOLD\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                        "type": "text"
                    },
                    {
                        "backdrop": {
                            "transparency": "0.8"
                        },
                        "blocks": [
                            {
                                "type": "text"
                            },
                            {
                                "text": "{\"blocks\":[{\"key\":\"2alog\",\"text\":\"Positivt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1mp1d\",\"text\":\"Utslippsfri\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":11,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bmqa2\",\"text\":\"Tar mindre plass enn vindmøller\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":31,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ctr2i\",\"text\":\"Det er sol overalt\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":18,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"d2d25\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"9b1o7\",\"text\":\"Negativt:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":9,\"style\":\"BOLD\"},{\"offset\":0,\"length\":9,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cpmfr\",\"text\":\"Forurensende produksjon\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":23,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ep76t\",\"text\":\"Gir ujevn tilgang til strøm\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":27,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2t4fk\",\"text\":\"Klarer kun å omdanne 15% av energien som er i sollyset til elektrisk energi\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":75,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"7fn97\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                                "type": "text"
                            }
                        ],
                        "buttonColor": "#F28600",
                        "buttonText": "Les mer",
                        "contentType": "dialog",
                        "icon": "info",
                        "roundedCorners": true,
                        "type": "readMore"
                    }
                ],
                "endColumn": 12,
                "startColumn": 7
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 15,
        "templateId": 2,
        "title": "Oppgave energikilder",
        "type": "content",
        "verticalAlign": "top"
    },
    {
        "backgroundColor": "#8fbad8ff",
        "containers": [
            {
                "blocks": [
                    {
                        "alternatives": [
                            {
                                "alternative": "a",
                                "text": "Gass, atomkraft, vindkraft"
                            },
                            {
                                "alternative": "b",
                                "text": "Solkraft, kull, atomkraft"
                            },
                            {
                                "alternative": "c",
                                "text": "Kull, vannkraft, gass"
                            }
                        ],
                        "answer": "c",
                        "locked": true,
                        "question": "Hvilke metoder tror dere aluminiumindustrien globalt bruker mest i dag til elektrolyse? ",
                        "type": "quiz"
                    }
                ],
                "endColumn": 12,
                "removable": true,
                "startColumn": 2
            }
        ],
        "excludeFromNav": true,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "rgba(0, 0, 0, 0.7)",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 16,
        "templateId": 2,
        "title": "Oppgave energi ",
        "type": "content",
        "verticalAlign": "top"
    },
    {
        "backgroundColor": "#ffffffff",
        "containers": [
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"dps55\",\"text\":\"Kim er glad for at aluminiumindustrien satser på fornybar energi, men synes fremdeles det virker svært kraftkrevende å lage metallet.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":133,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            },
            {
                "backgroundColor": "#f28600ff",
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"9jl18\",\"text\":\"Da hjelper det å vite at aluminium lar seg gjenbruke i det uendelige. Kim reiser til en fabrikk i Holmestrand, som resirkulerer aluminium. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":139,\"style\":\"SIZE_LG\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": false,
                "endColumn": 6,
                "horizontalAlign": "center",
                "removable": true,
                "startColumn": 2,
                "stepPosition": "bottom"
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "mapCoords": {
            "from": [
                6.072838821186577,
                61.219931343644475
            ],
            "to": [
                10.321625578222706,
                59.487803026079575
            ]
        },
        "minHeight": "500dvh",
        "order": 17,
        "templateId": 7,
        "title": "Resirkulering",
        "type": "stickyMap",
        "verticalAlign": "center",
        "zoom": 10
    },
    {
        "backgroundColor": "#111d11ff",
        "containers": [
            {
                "blocks": [
                    {
                        "imagePath": "019EE8ijLUJG5",
                        "type": "image"
                    },
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"6qkq1\",\"text\":\"Haug med skrapmetall på fabrikken i Holmestrand. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":49,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":49,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":49,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"b1iin\",\"text\":\"Foto: Roy Stranna.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":18,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":18,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":18,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 8,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "imagePath": "019EE8ijLTyEX",
                        "type": "image"
                    },
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"r16f\",\"text\":\"Sammenpresset skrapmetall. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":27,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":27,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":27,\"style\":\"color-#ffffff\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"bo2m5\",\"text\":\"Foto: Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":12,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":12,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":12,\"style\":\"color-#ffffff\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "horizontalAlign": "center",
                "startColumn": 6
            }
        ],
        "excludeFromNav": true,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "150vh",
        "order": 18,
        "templateId": 3,
        "title": "Resirkulering",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#c3c5d4ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"kru9\",\"text\":\"For å resirkulere aluminium trengs bare 5% av den energien som brukes til å produsere ny aluminium. Resirkulering av 1 tonn aluminium sparer 6 tonn bauksitt, dumping av 4 tonn rødslam og utslipp av rundt 9 tonn CO2, avhengig av hva kraftkilden er.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":247,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"eodld\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1gm0t\",\"text\":\"På fabrikken følger Kim prosessen fra omsmelting av skrapmetall til nye produkter, som bildeler. Skrapmetall er produkter som inneholder metall, og kan være alt fra gamle bildeler til kabler og takrenner.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":204,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"fi6e4\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"3ll9r\",\"text\":\"I løpet av de siste årene er bruken av aluminium i biler blitt firedoblet. Aluminium brukes i felger, motorer, girkasser og karosserier. Opp mot 200 kg av hver nyproduserte bil i 2024 er aluminium. Målet er at det skal bli mye mer, for å redusere utslippet av klimagasser.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":272,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"o9q0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "excludeFromNav": true,
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 19,
        "templateId": 2,
        "title": "Resirkulering",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#111d11ff",
        "containers": [
            {
                "blocks": [
                    {
                        "imagePath": "019EE8ijLTyAD",
                        "type": "image"
                    },
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"c4o7m\",\"text\":\"Skrapmetallet smeltes i om i store over. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":41,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":41,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":41,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"adbop\",\"text\":\"Foto: Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":12,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":12,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":12,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 8,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "imagePath": "019EE8ijLTyEY",
                        "type": "image"
                    },
                    {
                        "placeholder": "Klikk her for å skrive",
                        "text": "{\"blocks\":[{\"key\":\"5ckb8\",\"text\":\"På fabrikken i Holmestrand lager de blant annet coiler, som kan bli til mange andre produkter. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":95,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":95,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":95,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9kj2b\",\"text\":\"Foto: Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":12,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":12,\"style\":\"SIZE_STANDARD\"},{\"offset\":0,\"length\":12,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "horizontalAlign": "center",
                "startColumn": 6
            }
        ],
        "excludeFromNav": true,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "150vh",
        "order": 20,
        "templateId": 3,
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#1e4f32ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"8jtph\",\"text\":\"Industrien har som mål å resirkulere alle bildeler. Det vil bidra til at resirkulert aluminium kan dekke halvparten av de 200 millioner tonnene med aluminium som trengs i 2050.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":176,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":176,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":176,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"9171t\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2nfgi\",\"text\":\"Derfor må vi, uavhengig av hva metallet har vært brukt til, resirkulere mer!\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":76,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":76,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":76,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2adi1\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"f9jbk\",\"text\":\"Ikke alt skrapmetall lar seg resirkulere, men hvis vi klarer å sortere metallene enda bedre, vil de bli lettere å bruke om igjen.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":129,\"style\":\"SIZE_XL2\"},{\"offset\":0,\"length\":129,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":129,\"style\":\"fontfamily-Arial\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "borderRadius": true,
                "endColumn": 7,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "backgroundColor": "#1e4f32ff",
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE8ijLUe3i",
                        "showCaptionIcon": false,
                        "type": "image"
                    },
                    {
                        "text": "{\"blocks\":[{\"key\":\"fg35u\",\"text\":\"Biler som skal resirkuleres. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":29,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":29,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":29,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"2vcsi\",\"text\":\"Foto: Hydro. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":13,\"style\":\"fontfamily-Arial\"},{\"offset\":0,\"length\":13,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":13,\"style\":\"SIZE_STANDARD\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "startColumn": 7
            }
        ],
        "excludeFromNav": true,
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 21,
        "templateId": 2,
        "title": "Resirkulering",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#8fbad8ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"1j9fh\",\"text\":\"Hvordan kan vi resirkulere mer aluminium? \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":42,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8spis\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"aimrd\",\"text\":\"Hvordan kan vi som forbrukere resirkulere mer, og hvordan kan industrien resirkulere mer?\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":89,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8trap\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"h6js\",\"text\":\"Diskuter i grupper og kom med nye forslag.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":42,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"8rovg\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"3q6pu\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 22,
        "templateId": 2,
        "title": "Oppgave resirkulering",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#ffffffff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"cvcub\",\"text\":\"Valgomat\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":8,\"style\":\"SIZE_XL7\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"ijvs\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"ror4\",\"text\":\"Lenke: \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":7,\"style\":\"SIZE_XL7\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "excludeFromNav": false,
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 23,
        "templateId": 2,
        "title": "Test dine meninger om klima og miljø",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#1e4f32ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"57s53\",\"text\":\"På bakgrunn av det dere har funnet ut om aluminium:\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":51,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":51,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"2vtu0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"bct7u\",\"text\":\"Bør Kim kjøpe seg bil? Bli enig i gruppa.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":41,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":41,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"75et9\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"3c4o0\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"b2ak9\",\"text\":\"Diskuter felles hva dere har kommet frem til og begrunn.  \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":58,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":58,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"e7j5c\",\"text\":\" \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":1,\"style\":\"color-#ffffff\"},{\"offset\":0,\"length\":1,\"style\":\"SIZE_XL2\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}},{\"key\":\"9agt7\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"left\"}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 5
            }
        ],
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 24,
        "templateId": 2,
        "title": "Avslutning",
        "type": "content",
        "verticalAlign": "center"
    },
    {
        "backgroundColor": "#c3c5d4ff",
        "containers": [
            {
                "blocks": [
                    {
                        "placeholder": "Klikk her for å skrive. Bruk enter-tasten for å lage avsnitt. For å legge til andre innholdsblokker, som for eksempel bilder, må du klikke på beholderen som omslutter denne tekstblokken.",
                        "text": "{\"blocks\":[{\"key\":\"c0olu\",\"text\":\"Bildekreditering historie \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":26,\"style\":\"UNDERLINE\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"1pokj\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"bpcdk\",\"text\":\"Bilde 1. Foto: Nordroden, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8jdr4\",\"text\":\"Bilde 2. Av: FlyingCrafter, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2rfqi\",\"text\":\"Bilde 4. Promobilde fra BMW. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6t5lr\",\"text\":\"Bilde 5 og 18. Pond5 bildebank.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"1pcgi\",\"text\":\"Bilde 6. Foto: Daria Kashurina, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"11qo\",\"text\":\"Bilde 7. Foto: Luoman, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8mqjd\",\"text\":\"Bilde 3, 8–12, 14, 15, 17 og 20. Foto fra Hydro.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7v4sr\",\"text\":\"Bilde 16. Creative Commons. Kreditering Leaflet, CC BY-SA 3.0.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"fgtak\",\"text\":\"Bilde 19, 21 og 22. Foto: Roy Stranna.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"dopj4\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"a4r42\",\"text\":\"Bildekreditering utstilling\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":27,\"style\":\"UNDERLINE\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"3dj10\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"2jd0q\",\"text\":\"Hovedbilde. Foto: Roy Stranna. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"cq3a1\",\"text\":\"Bilde 1: Forside historie. Foto: Roy Stranna.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7v431\",\"text\":\"Bilde 2: Forside quiz. Foto: Roy Stranna. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"3bsl5\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 6,
                "horizontalAlign": "center",
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "text": "{\"blocks\":[{\"key\":\"6frv7\",\"text\":\"Bildekreditering valgomat\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":25,\"style\":\"UNDERLINE\"}],\"entityRanges\":[],\"data\":{}},{\"key\":\"cl6ek\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"14vas\",\"text\":\"Forside. Foto: Ramdan Nain, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"eirbs\",\"text\":\"Bilde 1, 7, 9 og 15. Foto: Roy Stranna.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7du2j\",\"text\":\"Bilde 2. Av Paralaxis, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"d0qc8\",\"text\":\"Bilde 3. Foto: Liukov, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"6jlv1\",\"text\":\"Bilde 4. Foto: Nicola Ferrari, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5kcfp\",\"text\":\"Bilde 5. Foto: TomasSereda, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"41mhk\",\"text\":\"Bilde 6. Foto: teppakorn tongboonto, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"4ojje\",\"text\":\"Bilde 8. Foto: shironosov, iStock. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"7enee\",\"text\":\"Bilde 10. Foto: phaisarn2517, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"eu30b\",\"text\":\"Bilde 11. Foto: sssanchez, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"50gtv\",\"text\":\"Bilde 12. Foto: johan10, iStock. \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"a2hru\",\"text\":\"Bilde 13. Foto: eric1513, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"e6qlk\",\"text\":\"Bilde 14. Foto: gorodenkoff, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"rl38\",\"text\":\"Bilde Teknologioptimisten. Foto: ipopba, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"31gih\",\"text\":\"Bilde Diplomaten. Foto: Denisfilm, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"8h23t\",\"text\":\"Bilde Naturelskeren. Foto: oatawa, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"5e0bb\",\"text\":\"Bilde Happy og lucky. Foto: oatawa, iStock.\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}},{\"key\":\"akq2c\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                        "type": "text"
                    }
                ],
                "endColumn": 12,
                "removable": true,
                "startColumn": 8
            },
            {
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE9hvzUoDX",
                        "showCaptionIcon": false,
                        "type": "image"
                    }
                ],
                "endColumn": 6,
                "removable": true,
                "startColumn": 2
            },
            {
                "blocks": [
                    {
                        "altText": "",
                        "imagePath": "019EE9hvzUoDZ",
                        "showCaptionIcon": false,
                        "type": "image"
                    }
                ],
                "endColumn": 12,
                "removable": true,
                "startColumn": 8
            }
        ],
        "gridSize": "twelveColumns",
        "lock": {
            "backgroundColor": "#FFFFFF",
            "endColumn": 6,
            "horizontalAlign": "center",
            "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
            "startColumn": 5,
            "unlockedLabel": "Du kan scrolle videre"
        },
        "minHeight": "100vh",
        "order": 25,
        "templateId": 2,
        "title": "Bildekreditering",
        "type": "content",
        "verticalAlign": "center"
    }
],
    "settings": {
    "colors": [
        {
            "key": 0,
            "value": "#1e4f32"
        },
        {
            "key": 1,
            "value": "#c3c5d4"
        },
        {
            "key": 2,
            "value": "#f28600"
        },
        {
            "key": 3,
            "value": "#111d11"
        }
    ],
        "enableNav": true
}

}